export const LOCALISATION_ENABLED_PATHS = ['v2', 'product'] // to check if localisation enabled based on the pathname
export const DEFAULT_LOCALE = 'en'
export const AVAILABLE_LOCALES_HEADER = 'X-Available-Locales'
export const USER_PREFERRED_LANGUAGE_COOKIE = 'user-preferred-language'
export const SUPPORTED_LANGUAGES = ['en', 'hi', 'ta', 'te', 'kn', 'ml']
export const LOCALE_SELECTOR_SOURCE_COOKIE = 'locale-selector-source'
export const LOCALE_TOOLTIP_TARGET_ID = 'language-selector'
